module.exports = __webpack_public_path__ + "media/images/dmc/tour-06-6e274582d5a795c04876bbcce2f9af72.jpg";